/**
 * @flow
 * @relayHash 8bdec85622582a1ba65eb986f2c28e23
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SowingAddQueryVariables = {||};
export type SowingAddQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type SowingAddQuery = {|
  variables: SowingAddQueryVariables,
  response: SowingAddQueryResponse,
|};
*/


/*
query SowingAddQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SowingAddQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SowingAddQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SowingAddQuery",
    "id": null,
    "text": "query SowingAddQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c311f0cd9050221cb5ee1c21e7312def';
module.exports = node;
